import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const getPartnerSkinPrefs = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			partner_id: data.partner_id,
			request: 'GetPartnerSkinPrefs',
		})
		.then((res) => {
			return res;
		});

export const setPartnerSkinPrefs = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			partner_id: data.partner_id,
			prefs: data.pref,
			action: 'replace',
			request: 'SetPartnerSkinPrefs',
		})
		.then((res) => {
			return res;
		});

export const getPartnerGameSettings = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			partner_id: data.partner_id,
			game_id: data.game_id,
			currency: data.currency,
			request: 'GetPartnerGameSettings',
		})
		.then((res) => {
			return res;
		});
